<mat-dialog-content>
  <div class="root">
    <mat-toolbar [color]="color" class="header">
      <div class="placeholder"></div>

      <div class="time-frame">
        <span
          class="time fixed-font-size"
          [ngClass]="{ select: this.viewType === 'hours' && 'active' }"
          (click)="editHours()"
        >
          {{ twoDigits(formattedHours) }}
        </span>

        <span class="fixed-font-size">:</span>

        <span
          class="time fixed-font-size"
          [ngClass]="{ select: this.viewType === 'minutes' && 'active' }"
          (click)="editMinutes()"
        >
          {{ twoDigits(minutes) }}
        </span>
      </div>

      <!-- <ng-container *ngIf="mode === '12h'; then ampm; else normal"></ng-container> -->
      <ng-container [ngTemplateOutlet]="ampm"></ng-container>

      <ng-template #normal>
        <div class="placeholder"></div>
      </ng-template>

      <ng-template #ampm>
        <div class="ampm">
          <span class="time" [ngClass]="{ select: isPm }" (click)="setPm()">
            {{ postMeridiemAbbreviation | uppercase }}
          </span>
          <span class="time" [ngClass]="{ select: !isPm }" (click)="setAm()">
            {{ anteMeridiemAbbreviation | uppercase }}
          </span>
        </div>
      </ng-template>
    </mat-toolbar>

    <div class="body">
      <red-clock
        [allowed12HourMap]="allowed12HourMap"
        [allowed24HourMap]="allowed24HourMap"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [color]="color"
        [viewType]="viewType"
        [mode]="mode"
        [isPm]="isPm"
        [formattedHours]="formattedHours"
        [minutes]="minutes"
        [formattedValue]="viewType === 'minutes' ? minutes : formattedHours"
        (changeEvent)="handleClockChange($event)"
        (unavailableSelection)="handleUnavailableSelection()"
        (invalidMeridiem)="invalidMeridiem()"
        (mouseup)="handleClockChangeDone($event)"
        (clearInvalidMeridiem)="clearInvalidMeridiem()"
        (touchend)="handleClockChangeDone($event)"
        (invalidSelection)="invalidSelectionHandler($event)"
      ></red-clock>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" mat-button (click)="cancelClickHandler()">Cancel</button>
  <button type="button" mat-button class="cimb-button--primary" (click)="okClickHandler()">Save</button>
</mat-dialog-actions>
